import Vue from 'vue'
import VueI18n from 'vue-i18n'
import languageConfig from '@src/common/config/language'

// 支持的语种及描述，也用于页面展示
const LANGUAGES = [];
const messages = {};

for (let key in languageConfig.LANGUAGE_MAP) {
  LANGUAGES.push({
    value: key,
    name: languageConfig.LANGUAGE_MAP[key].name
  });
  const localI18n = languageConfig.LANGUAGE_MAP[key].localI18n;
  const elI18n = languageConfig.LANGUAGE_MAP[key].elI18n;
  messages[key] = {
    message: languageConfig.LANGUAGE_MAP[key].name,
    ...require(`@src/common/lang/${localI18n}`).default,
    ...require(`element-ui/lib/locale/lang/${elI18n}`).default
  };
}

// 默认语种
const DEFAULT_LOCALE = languageConfig.DEFAULT_LANGUAGE || LANGUAGES[0].value;

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  messages
});

// 挂载支持的语种，用于页面循环展示，如：下拉框
i18n.LANGUAGES = LANGUAGES;

/**
 * 设置i18n的语种
 * @param newLocale
 * @param oldLocale
 */
i18n.setLocale = function (newLocale) {
  i18n.locale = newLocale;
};

export default i18n
